export const actions = {
    REQUEST_UPLOAD: "REQUEST_UPLOAD",
    START_UPLOAD: "START_UPLOAD",
    FILE_UPLOADED: "FILE_UPLOADED",
    FILE_UPLOAD_FAILED: "FILE_UPLOAD_FAILED",
    UPLOAD_FINISHED: "UPLOAD_FINISHED",
};

export const initialState = {
    loading: false,
    uploads: [],
};

export default (
    state = initialState,
    { type, uploadId, recordId, recordName, recordType, fileName, fileInfos }
) => {
    switch (type) {
        case actions.REQUEST_UPLOAD: {
            return {
                ...state,
                loading: true,
            };
        }

        case actions.START_UPLOAD: {
            const newUploads = Array.from(state.uploads);
            fileInfos.forEach((fileInfo) =>
                newUploads.push({
                    uploadId,
                    recordId: null,
                    fileName: fileInfo.name,
                    recordName: null,
                    recordType,
                    success: null,
                })
            );
            return {
                ...state,
                loading: true,
                uploads: newUploads,
            };
        }

        case actions.FILE_UPLOADED: {
            const newUploads = Array.from(state.uploads);
            const entry = newUploads.find(
                (u) => u.uploadId === uploadId && u.fileName === fileName
            );
            entry.recordId = recordId;
            entry.recordName = recordName;
            entry.success = true;
            entry.recordType = recordType || entry.recordType;
            return {
                ...state,
                uploads: newUploads,
            };
        }

        case actions.FILE_UPLOAD_FAILED: {
            const newUploads = Array.from(state.uploads);
            const entry = newUploads.find(
                (u) => u.uploadId === uploadId && u.fileName === fileName
            );
            entry.recordId = recordId;
            entry.recordName = recordName;
            entry.success = false;
            return {
                ...state,
                uploads: newUploads,
            };
        }

        case actions.UPLOAD_FINISHED: {
            return {
                ...state,
                loading: false,
            };
        }

        default:
            return state;
    }
};
